var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card advertisement is-radiusless is-shadowless",class:{
    'is-bg-grey': !_vm.isBanner && _vm.isBackgroundGrey,
    'py-3': !_vm.isBanner && _vm.isFromHome && _vm.currentBreakPoint === _vm.xsBreakPoint()
  }},[_c('div',{staticClass:"card-body",class:{ 'side-ad': !_vm.isBanner }},[_c('client-only',[_c('GptAd',{ref:"gptAds",attrs:{"ad-unit":_vm.adUnit,"size":_vm.size,"size-mapping":_vm.sizeMapping}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }